export const regExpressionChecker = (regex, input) => {
  if (regex) {
    return regex.test(input);
  }
  return !!regex;
};
